import { GetterTree } from 'vuex';
import { RallyIntelligenceState, RootState } from '../types';

export const getters: GetterTree<RallyIntelligenceState, RootState> = {
	getPrompts(state): RallyIntelligencePromptResponse[] {
		return state.prompts;
	},

	getConfiguration(state): RallyIntelligenceConfigurationResponse | null {
		return state.configuration;
	},

	getMonthlyTokensRemaining(state): number {
		return state.usage?.monthly_remaining ?? 0;
	},

	getFetchPromptsComplete(state): boolean {
		return state.fetchPromptsComplete;
	}
};
